import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=027407e8&scoped=true&"
import script from "./modal.vue?vue&type=script&lang=ts&"
export * from "./modal.vue?vue&type=script&lang=ts&"
import style0 from "./modal.vue?vue&type=style&index=0&id=027407e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027407e8",
  null
  
)

export default component.exports